import { effect, Injectable, signal } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { KeyStorage } from '../constants/key-storage.stor';
import { Theme } from '../models/theme.model';
import { AppStorageService } from './store/app-storage.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  public theme = signal<Theme>({
    // mode: 'dark',
    // color: 'base',
    mode: 'light',
    color: 'blue',
    direction: 'ltr',
    language: 'en',
  });

  private darkTheme$ = new BehaviorSubject<boolean>(false);
  darkTheme = this.darkTheme$.asObservable();

  constructor(private transloco: TranslocoService, private storage: AppStorageService) {
    this.loadTheme();
    effect(() => {
      this.setConfig();
    });
  }

  private loadTheme() {
    // const theme = localStorage.getItem(KeyStorage.keyTheme);
    // const theme = this.storage.getItem<string>(KeyStorage.keyTheme);
    const theme = this.storage.getItem<Theme>(KeyStorage.keyTheme);
    if (theme) {
      // this.theme.set(JSON.parse(theme));
      this.theme.set(theme);
    }
  }

  private setConfig() {
    this.setLocalStorage();
    this.setThemeClass();
    this.setRTL();
    this.setLang();
  }

  public get isDark(): boolean {
    return this.theme().mode == 'dark';
  }

  public get isArabic(): boolean {
    return this.theme().language == 'ar';
  }

  public get getLanguage(): String {
    return this.theme().language.toLowerCase();
  }

  public toggleTheme(isDark: boolean) {
    this.darkTheme$.next(isDark);
  }

  private setThemeClass() {
    document.querySelector('html')!.className = this.theme().mode;
    document.querySelector('html')!.setAttribute('data-theme', this.theme().color);
  }

  private setLocalStorage() {
    // localStorage.setItem(KeyStorage.keyTheme, JSON.stringify(this.theme()));
    this.storage.setItem<string>(KeyStorage.keyTheme, JSON.stringify(this.theme()));
    this.storage.setItem<Theme>(KeyStorage.keyTheme, this.theme());
  }

  private setRTL() {
    document.querySelector('html')!.setAttribute('dir', this.theme().direction);
    this.setLocalStorage();
  }

  private setLang() {
    document.querySelector('html')!.setAttribute('lang', this.theme().language);
    this.transloco.setActiveLang(this.theme().language);
    this.setLocalStorage();
  }
}
